module.exports = __webpack_public_path__ + "img/34.df8d5174.png";